import React from 'react'
import { observer } from 'mobx-react'
import Input from '../generic/Input'
import FormRenderer from '../generic/FormRenderer'
import Button from '../generic/Button'
import { inject } from 'mobx-react'

const ForgotPasswordForm = inject('forgotPasswordStore')(observer((props) => {
  const { forgotPasswordStore } = props
  const { email, verificationCode, newPassword, isSendingCode, isConfirming } = forgotPasswordStore.user
  const forgotPasswordFields = [
    {
      component: Input,
      label: 'E-mail',
      type: 'text',
      name: 'email',
      id: 'confirm-user-email',
      placeholder: 'E-mail',
      value: email
    },
    {
      component: Button,
      text: 'Enviar código',
      type: 'submit',
      onClick: (event) => forgotPasswordStore.sendVerificatonCode(event),
      id: 'confirm-user-send-code',
      isLoading: isSendingCode,
      styleClass: 'app-main-button'
    }
  ]
  const forgotPasswordCodeFields = [
    {
      component: Input,
      label: 'Código',
      type: 'text',
      name: 'verificationCode',
      id: 'confirm-user-verification-code',
      placeholder: 'Código de verificação',
      value: verificationCode
    },
    {
      component: Input,
      label: 'Nova senha',
      type: 'password',
      name: 'newPassword',
      id: 'confirm-user-new-password',
      placeholder: 'Nova senha',
      value: newPassword
    },
    {
      component: Button,
      text: 'Confirmar senha',
      type: 'submit',
      onClick: (event) => forgotPasswordStore.confirmPassword(event),
      id: 'confirm-user-confirm-password',
      isLoading: isConfirming,
      styleClass: 'app-main-button'
    }
  ]
  return (
    <div>
      <form>
        <FormRenderer fields={forgotPasswordFields} store={forgotPasswordStore} />
      </form>
      <br />
      <form>
        <FormRenderer fields={forgotPasswordCodeFields} store={forgotPasswordStore} />
      </form>
    </div>
  )
}))

export default ForgotPasswordForm



// WEBPACK FOOTER //
// ./src/components/forgot-password/ForgotPasswordForm.js